import { Component, Optional, AfterViewInit, Inject } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { AddressService } from '@app/services/address.service';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastService } from '@app/services/toast.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BreadcrumbService } from '@app/services/breadcrumb.service';

declare let google: any;
interface AddressSuggestion {
  title: string;
  subtitle: string;
  fullAddress: string;
  placeId: string;          // Google placeId fetch ke liye
  latitude?: number;        // optional, select ke baad fill hoga
  longitude?: number;
}
interface EditAddressData {
  id: number;
  address: string;
  latitude: string | number;
  longitude: string | number;
}


interface AddressFormData {
  fullAddress: string;
  latitude: number | null;
  longitude: number | null;
}
@Component({
  selector: 'app-add-address-listing',
  templateUrl: './add-address-listing.component.html',
  styleUrl: './add-address-listing.component.scss'
})
export class AddAddressListingComponent {
  addressForm: FormGroup;

  isLoading: boolean = false;
  // Autocomplete
  showAutocomplete: boolean = false;
  addressSuggestions: AddressSuggestion[] = [];

  // Selected address
  selectedAddress: string | null = null;
  selectedLatitude: number | null = null;
  selectedLongitude: number | null = null;

  // Manual entry
  manualEntryEnabled: boolean = false;

  // Map
  mapUrl: SafeResourceUrl | null = null;
  showMap: boolean = false;
  autocompleteService!: google.maps.places.AutocompleteService;
  placesService: any;
  // Sample suggestions (replace with Google Places API)

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private sanitizer: DomSanitizer, public location: Location, public addressService: AddressService, public authService: AuthServiceService, public toast: ToastService, @Optional() public dialogRef: MatDialogRef<AddAddressListingComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private shareddta: ShareddtaService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.addressForm = this.fb.group({
      addressSearch: ['', Validators.required],
      fullAddress: ['', Validators.required],
      latitude: [null],
      longitude: [null],
      manualEntryEnabled: [false]
    });
    this.url = this.router.url;
    //   this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    //   `https://www.google.com/maps?q=26.8,80.9&z=6&output=embed`
    // );
    //  if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(
    //     (position) => {
    //       const lat = position.coords.latitude;
    //       const lng = position.coords.longitude;
    //       this.initMap(lat, lng); // user location
    //     },
    //     (error) => {
    //       console.warn('Location not allowed, using default', error);
    //       this.initMap(26.7613, 83.3666); // Gorakhpur default
    //     }
    //   );
    // } else {
    //   this.initMap(26.7613, 83.3666); // fallback if browser does not support
    // }
  }
  ngAfterViewInit(): void {
    // DOM ready, now #map exists
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => this.initMap(pos.coords.latitude, pos.coords.longitude),
        () => this.initMap(26.7613, 83.3666) // Gorakhpur fallback
      );
    } else {
      this.initMap(26.7613, 83.3666);
    }
    this.shareddta.signalPageReady();
  }
  isEditMode: boolean = false;
  ngOnInit(): void {
    if (this.url === '/admin/address/add') {
      this.breadcrumbService.set([
        { label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', action: () => this.router.navigate(['/admin/dashboard']) },
        { label: 'Addresses', action: () => this.router.navigate(['/admin/address']) },
        { label: 'Add Address' }
      ]);
    }

    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.placesService = new google.maps.places.PlacesService(document.createElement('div'));

    // Listen to search input changes
    this.addressForm.get('addressSearch')?.valueChanges
      .pipe(
        debounceTime(300),          // wait 300ms after the last keystroke
        distinctUntilChanged()      // only emit if the value actually changed
      )
      .subscribe(value => {
        this.handleSearchChange(value);
      });
    const editData = history.state.address;
    if (editData) {
      // edit mode
      this.isEditMode = true;

      // Patch form values
      this.addressForm.patchValue({
        addressSearch: editData.address,   // ✅ now safe
        fullAddress: editData.address,
        latitude: editData.latitude,
        longitude: editData.longitude
      });
      this.hasSelectedAddress = true;
      this.selectedAddress = editData.address;
      this.selectedLatitude = Number(editData.latitude);
      this.selectedLongitude = Number(editData.longitude);
      setTimeout(() => {
        if (this.selectedLatitude && this.selectedLongitude) {
          this.updateMap(this.selectedLatitude, this.selectedLongitude);
        }
      }, 1000);

    }

    if (this.data && this.data.addressText) {
      this.addressForm.patchValue({
        addressSearch: this.data.addressText,
        fullAddress: this.data.addressText
      }, { emitEvent: false });
      this.handleSearchChange(this.data.addressText);
    }
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  // Handle search input change
  handleSearchChange(searchTerm: string): void {
    if (!searchTerm || searchTerm.length < 1) {
      this.showAutocomplete = false;
      this.addressSuggestions = [];
      return;
    }

    this.autocompleteService.getPlacePredictions(
      {
        input: searchTerm,
      },
      (predictions: google.maps.places.AutocompletePrediction[] | null, status: google.maps.places.PlacesServiceStatus) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
          this.addressSuggestions = predictions.map(p => ({
            title: p.structured_formatting.main_text,
            subtitle: p.structured_formatting.secondary_text,
            fullAddress: p.description,
            placeId: p.place_id
          }));
          this.showAutocomplete = true; // Ensure visibility when results are found
        } else {
          this.addressSuggestions = [];
          this.showAutocomplete = false;
        }
      }
    );
  }


  // Select address from autocomplete
  // selectAddressFromAutocomplete(suggestion: AddressSuggestion): void {
  //   this.selectedAddress = suggestion.fullAddress;
  //   this.selectedLatitude = suggestion.latitude;
  //   this.selectedLongitude = suggestion.longitude;

  //   // Update form
  //   this.addressForm.patchValue({
  //     addressSearch: suggestion.fullAddress,
  //     fullAddress: suggestion.fullAddress,
  //     latitude: suggestion.latitude,
  //     longitude: suggestion.longitude
  //   });

  //   // Hide autocomplete
  //   this.showAutocomplete = false;

  //   // Update map
  //   this.updateMap(suggestion.latitude, suggestion.longitude);
  // }
  selectAddressFromAutocomplete(suggestion: AddressSuggestion): void {
    this.hasSelectedAddress = false;
    if (!this.placesService || !suggestion.placeId) {
      console.error('PlacesService not initialized or placeId missing');
      return;
    }

    this.placesService.getDetails(
      { placeId: suggestion.placeId },
      (place: { geometry: { location: { lat: () => any; lng: () => any; }; }; }, status: any) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place.geometry?.location) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();

          // Update selected address
          this.selectedAddress = suggestion.fullAddress;
          this.selectedLatitude = lat;
          this.selectedLongitude = lng;

          this.addressForm.patchValue({
            addressSearch: suggestion.fullAddress,
            fullAddress: suggestion.fullAddress,
            latitude: lat,
            longitude: lng
          }, { emitEvent: false });

          this.showAutocomplete = false;
          this.hasSelectedAddress = true;

          // Update map
          this.updateMap(lat, lng);
        } else {
          console.error('Failed to get place details:', status);
        }
      }
    );
  }




  // Toggle manual entry
  toggleManualEntry(): void {
    this.manualEntryEnabled = !this.manualEntryEnabled;

    if (!this.manualEntryEnabled) {
      // Clear manual coordinates
      this.addressForm.patchValue({
        latitude: this.selectedLatitude,
        longitude: this.selectedLongitude
      });
      this.showAutocomplete = false;
      this.hasSelectedAddress = true;
    }
  }

  // Update coordinates from manual entry
  onManualCoordinateChange(): void {
    const lat = this.addressForm.get('latitude')?.value;
    const lng = this.addressForm.get('longitude')?.value;

    if (lat !== null && lng !== null && !isNaN(lat) && !isNaN(lng)) {
      this.selectedLatitude = parseFloat(lat);
      this.selectedLongitude = parseFloat(lng);
      this.updateMap(this.selectedLatitude, this.selectedLongitude);
    }
  }
  initMap(lat: number, lng: number, zoom: number = 12): void {
    const mapOptions: google.maps.MapOptions = {
      center: new google.maps.LatLng(lat, lng),
      zoom: zoom
    };

    // Create map
    this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, mapOptions);

    // Create marker
    this.marker = new google.maps.Marker({
      position: new google.maps.LatLng(lat, lng),
      map: this.map
    });

    this.showMap = true;
  }

  // Update map
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  updateMap(latitude: number, longitude: number): void {
    if (!this.map) {
      console.error('Map not initialized yet');
      return;
    }

    const position = new google.maps.LatLng(latitude, longitude);

    // Center map on new coordinates
    this.map.setCenter(position);
    this.map.setZoom(15);

    // Move or create marker
    if (this.marker) {
      this.marker.setPosition(position);
    } else {
      this.marker = new google.maps.Marker({
        position: position,
        map: this.map
      });
    }

    // Show map if hidden
    this.showMap = true;
  }


  // Format coordinate to 6 decimals
  formatCoordinate(value: number | null): string {
    return value !== null ? value.toFixed(6) : '-';
  }

  // Check if address is selected
  // get hasSelectedAddress(): boolean {
  //   return this.selectedAddress !== null && 
  //          this.selectedLatitude !== null && 
  //          this.selectedLongitude !== null;
  // }

  // Hide autocomplete (when clicking outside)
  hasSelectedAddress: boolean = false;
  hideAutocomplete(): void {

    setTimeout(() => {
      this.showAutocomplete = false;
    }, 300);
  }

  // Show autocomplete on focus
  onSearchFocus(): void {
    this.showAutocomplete = true;
  }

  // Submit form
  isSubmitting: boolean = false;
  url: any;
  onSubmit(): void {
    if (this.addressForm.invalid) {
      this.addressForm.markAllAsTouched();
      // alert('Please fill in all required fields');
      return;
    }
    this.isSubmitting = true;

    const fullAddress = this.addressForm.get('fullAddress')?.value;

    if (!fullAddress) {
      // alert('Please enter a full address');
      return;
    }

    if (this.selectedLatitude === null || this.selectedLongitude === null) {
      // alert('Please select an address or enter coordinates');
      return;
    }
    if (this.isEditMode) {
      alert('Functionality is under progress');
    }
    else {
      // Create FormData
      const formData = new FormData();
      formData.append('address', fullAddress);
      formData.append('latitude', this.selectedLatitude.toString());
      formData.append('longitude', this.selectedLongitude.toString());

      console.log('Submitting address (FormData):', formData);

      // Call API to save address
      this.url = this.router.url;
      this.addressService.addressAdd(formData).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          if (this.authService.resultCodeError(response)) {
            return;
          }
          if (response.resultDescription) {
            this.toast.show('success', response.resultDescription);
            if (this.url == '/admin/address/add') {
              this.goBack(); // Navigate back or refresh
            }
            else {
              this.dialogRef.close({ action: 'saveDraft' });
            }
          }
        },
        error: (error) => {
          this.isSubmitting = false;
          console.error('Error saving address:', error);
          // If error is from resultCodeError throwing the data, the toast already showed.
          // We only alert if it's a real unexpected error.
          if (typeof error === 'string') {
            alert(error);
          }
        }
      });
    }
  }


  // Cancel and go back
  cancel(): void {
    if (this.url == '/admin/address/add') {
      this.goBack(); // Navigate back or refresh
    }
    else {
      this.dialogRef.close(false);
    }
  }

  // Navigate back to addresses list
  goBack(): void {
    if (this.url == '/admin/address/add') {
      this.location.back(); // Navigate back or refresh
    }
    else {
      this.dialogRef.close(true);
    }
  }
}
